import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterBar = ({ plays, filters, onFilterChange }) => {
  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Filter Options</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Play Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Play
          </label>
          <Select
            value={filters?.playId}
            onChange={(e) => handleFilterChange('playId', e?.target?.value)}
            className="w-full"
          >
            <option value="">All Plays</option>
            {plays?.map(play => (
              <option key={play?.id} value={play?.id}>{play?.title}</option>
            ))}
          </Select>
        </div>

        {/* Validation Status Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Validation Status
          </label>
          <Select
            value={filters?.validationStatus}
            onChange={(e) => handleFilterChange('validationStatus', e?.target?.value)}
            className="w-full"
          >
            <option value="all">All Status</option>
            <option value="pass">Passed</option>
            <option value="fail">Failed</option>
          </Select>
        </div>

        {/* Quality Issue Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Quality Issues
          </label>
          <Select
            value={filters?.qualityIssue}
            onChange={(e) => handleFilterChange('qualityIssue', e?.target?.value)}
            className="w-full"
          >
            <option value="all">All Issues</option>
            <option value="duration">Duration Issues</option>
            <option value="missing">Missing Audio</option>
            <option value="low_quality">Low Quality Score</option>
          </Select>
        </div>

        {/* Search */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Search
          </label>
          <Input
            type="text"
            placeholder="Line ID, character, dialogue..."
            value={filters?.searchQuery}
            onChange={(e) => handleFilterChange('searchQuery', e?.target?.value)}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
